import React from "react";

export interface SearchFilterItemProps {
  url: string;
  title: string;
  bundle: string | undefined;
}

export const SearchFilterItem: React.FC<SearchFilterItemProps> = ({
  url,
  title,
  bundle,
}) => (
  <a href={url} className="search-filter-item">
    {bundle ? (
      <>
        <span
          dangerouslySetInnerHTML={{ __html: title }}
          className="search-filter-item__title"
        />
        <span
          dangerouslySetInnerHTML={{ __html: bundle }}
          className="search-filter-item__bundle"
        />
      </>
    ) : (
      <span
        dangerouslySetInnerHTML={{ __html: title }}
        className="search-filter-item__title"
      />
    )}
  </a>
);
